import React from 'react';
import throttle from 'lodash.throttle';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { inViewForReact } from 'utils/common';

const defaultSkew = 500;

class Paginate extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.throttledPagintionInView = throttle(
      this.checkIfPaginationDomIsInView,
      100,
    );
    this.skew = this.props.skew || defaultSkew;
    this.loadPageCallback = this.props.loadPageCallback;
    window.addEventListener('scroll', this.throttledPagintionInView);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledPagintionInView);
  }

  componentDidUpdate() {
    this.loadPageCallback = this.props.loadPageCallback;
    if (this.props.data.totalPages <= this.props.data.currenPage) {
      window.removeEventListener('scroll', this.throttledPagintionInView);
    }
  }

  checkIfPaginationDomIsInView = () => {
    if (
      this.ref &&
      this.ref.current &&
      inViewForReact(this.ref.current, this.skew) &&
      !this.props.dataLoading &&
      this.props.data.totalPages > this.props.data.currenPage
    ) {
      const newPageNumber = parseInt(this.props.data.currenPage, 10) + 1;
      if (typeof this.loadPageCallback === 'function') {
        this.loadPageCallback(newPageNumber);
      }
    }
  };

  render() {
    return <div ref={this.ref} />;
  }
}

const mapStateToProps = state => ({
  data: state.homepage_us.data.pagination,
});

Paginate.propTypes = {
  data: PropTypes.shape({
    totalPages: PropTypes.number.isRequired,
    currenPage: PropTypes.number.isRequired,
  }).isRequired,
  loadPageCallback: PropTypes.func,
  skew: PropTypes.number,
  dataLoading: PropTypes.bool,
};

Paginate.defaultProps = {
  loadPageCallback: () => {},
  skew: 500,
  dataLoading: false,
};

export default connect(mapStateToProps)(Paginate);
